// A full page load, for paths the app does not own (Go serves them). Its own
// module so tests can observe it; jsdom's location.assign cannot be mocked.
export function fullPageLoad(url: string): void {
  window.location.assign(url);
}
